export type Page = {
  count: number,
  page: number
}
const buildPage = (count: number, page: number): Page => ({
  count: count,
  page: page
})
export {
  buildPage
}



// WEBPACK FOOTER //
// ./src/types/page.js